import { useIntl } from 'react-intl-next';

import type { SelectionExtension } from '@atlaskit/editor-plugin-selection-extension';
import PlusSquareIcon from '@atlaskit/icon/core/plus-square';
import type { ViewMode } from '@atlaskit/editor-plugin-editor-viewmode';

import { messages } from '../messages';

export type UseJiraWorkCreateSelectionExtensionProps = {
	viewMode: ViewMode | undefined;
	isLivePage: boolean | undefined;
	hasEditPermission: boolean | undefined;
};

export const useJiraWorkCreateSelectionExtension =
	({}: UseJiraWorkCreateSelectionExtensionProps): SelectionExtension => {
		const { formatMessage } = useIntl();

		return {
			name: formatMessage(messages.singleCreateWorkItemName),
			icon: PlusSquareIcon,
		};
	};
